import { NavLink } from 'react-router-dom';
import { Icone } from '../ui/Icone.js';
import { TemaToggle } from '../ui/TemaToggle.jsx';

/**
 * A faixa de cima das telas do OPERADOR — Plataforma e Operação.
 *
 * Elas são do Sand Sports, não de uma arena, e por isso não têm o menu
 * lateral nem o seletor de arena: só a marca, duas abas e a saída. A
 * credencial é a `OPERACAO_TOKEN` da aba, e sair a esquece.
 */
export function CabecalhoDoOperador({
  titulo,
  onSair,
}: {
  /** O nome da tela atual, ao lado da marca. */
  titulo: string;
  onSair: () => void;
}) {
  return (
    <header className="plat-top">
      <div className="linha">
        <img className="mark" src="/brand/simbolo.webp" alt="" />
        <b>Sand Sports</b>
        <i aria-hidden="true">/</i>
        <span className="titulo">{titulo}</span>
        <span className="selo">OPERADOR</span>
        <span style={{ flex: 1 }} />
        <TemaToggle />
        <button type="button" className="btn line sm" onClick={onSair}>
          <Icone nome="sair" />
          Sair
        </button>
      </div>
      <nav className="abas" aria-label="Seções do operador">
        <NavLink to="/plataforma">Arenas</NavLink>
        <NavLink to="/operacao">Operação</NavLink>
      </nav>
    </header>
  );
}
